import React, { memo } from 'react'

import { formatTicks } from '../../util/string.helpers'
import { percentageOfCompletion } from '../../util/number.helpers'
import RedeemTitle from './RedeemTitle'
import CustomProgressBar from '../shared/progressBar/CustomProgressBar'

const RedeemProgress = ({
  currentUserPoints,
  value,
  name,
  isNft,
  tokenSymbol,
  iconSize = 'sm',
  titleProps,
  progressTextSx,
  noTitle = false
}) => {
  const completed = percentageOfCompletion(currentUserPoints, value)
  const formattedValue = formatTicks(value)
  return (
    <CustomProgressBar
      title={
        !noTitle && (
          <RedeemTitle
            name={name}
            iconSize={iconSize}
            titleProps={titleProps}
            isNft={isNft}
          />
        )
      }
      label={`${tokenSymbol}: ${formatTicks(currentUserPoints)} / ${formattedValue}`}
      completed={completed}
      progressTextSx={progressTextSx}
    />
  )
}

export default memo(RedeemProgress)
